import React from 'react';
import './SunDesigns.css';

// 01 · Meridyen — Editöryel · veri tablosu
const D1Meridyen = ({ vm }) => (
  <div className="gsk">
    <div className="stage">
      <div className="d1">
        <div className="d1-rule"></div>
        <div className="d1-head">
          <div className="d1-place">
            {vm.district || vm.city}
            {vm.district && vm.city && <span> / {vm.city}</span>}
          </div>
          <div className="d1-date">{vm.dateShort}{vm.weekday ? ` — ${vm.weekday}` : ''}</div>
        </div>

        <div className="d1-row d1-row--rise">
          <span className="d1-dot"></span>
          <div className="d1-name">Güneşin Doğuşu<small>Sunrise</small></div>
          {vm.isDst ? (
            <>
              <div className="d1-cell"><span className="lbl">Normal</span><span className="num">{vm.sunriseNormal}</span></div>
              <div className="d1-cell d1-cell--main"><span className="lbl">Yaz saati</span><span className="num">{vm.sunriseDst}</span></div>
            </>
          ) : (
            <div className="d1-cell d1-cell--main"><span className="lbl">Saat</span><span className="num">{vm.sunriseDst}</span></div>
          )}
        </div>

        <div className="d1-row d1-row--set">
          <span className="d1-dot"></span>
          <div className="d1-name">Güneşin Batışı<small>Sunset</small></div>
          {vm.isDst ? (
            <>
              <div className="d1-cell"><span className="lbl">Normal</span><span className="num">{vm.sunsetNormal}</span></div>
              <div className="d1-cell d1-cell--main"><span className="lbl">Yaz saati</span><span className="num">{vm.sunsetDst}</span></div>
            </>
          ) : (
            <div className="d1-cell d1-cell--main"><span className="lbl">Saat</span><span className="num">{vm.sunsetDst}</span></div>
          )}
        </div>

        <p className="d1-foot">{vm.dstNote}</p>
      </div>
    </div>
  </div>
);

export default D1Meridyen;
